import { Link, LinkProps, Stack, Typography } from '@mui/material'
import { C1Icon } from 'components/core/icons/C1Icon'
import { ExternalLink as ExternalLinkIcon } from 'lucide-react'
import { ReactNode } from 'react'
import { ExternalLinkStyles } from './styles'

interface ExternalLinkProps extends LinkProps {
    href: string
    children: ReactNode
}

export const ExternalLink = ({ href, children, variant = 'body1', ...extraProps }: ExternalLinkProps): React.ReactElement => <Link
    target="_blank"
    rel="noopener"
    href={href}
    variant={variant}
    sx={ExternalLinkStyles.link}
    {...extraProps}
>
    <Stack display="inline-flex" direction="row" spacing={1} alignItems="center">
        <Typography component="span">{children}</Typography>
        <C1Icon
            icon={ExternalLinkIcon}
            role="img"
            aria-hidden="false"
            aria-label="Open in new tab"
        />
    </Stack>
</Link>
